import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';
import { EmergencyContact } from '../../resources';
import { ValidationError } from '../../errors';


export type GetUserEmergencyContactResponse = {
  data?: EmergencyContact;
};

export const getUserEmergencyContact = async (userId: string) =>
  restClient.request<GetUserEmergencyContactResponse>(`/api/v1/user/${userId}/emergency_contact`);

export type PutUserEmergencyContactInput = Pick<EmergencyContact, 'name' | 'relationship' | 'phone'>;
export type PutUserEmergencyContactResponse = {
  data: EmergencyContact;
};

export type PutUserEmergencyContactErrorResponse = ValidationError<PutUserEmergencyContactInput>;

export const putUserEmergencyContact = async (userId: string, data: PutUserEmergencyContactInput) =>
  restClient.request<PutUserEmergencyContactResponse>(
    `/api/v1/user/${userId}/emergency_contact`,
    {
      method: 'PUT',
      data: snakecaseKeys(data)
    }
  );
